import React, { PureComponent } from 'react';
import './WidgetMapaAvisos.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';
import { dayAfterTomorrow, dayNavColor } from '../../utils/utils';
import Header from '../../partials/Header/Header';
import logo from '../../img/logo.png';
import Nav from '../../partials/Nav/Nav';
import DayNav from '../../partials/DayNav/DayNav';
import AvisosNav from '../../partials/AvisosNav/AvisosNav';
import { Avisos } from '../../partials/Avisos/Avisos';
import Legend from '../../partials/Legend';
import { meteorsAvisos as meteors, PERILL_GRADES } from '../../utils/globals';
import { links } from '../../utils/urls';
import { DateTime } from 'luxon';

export class WidgetMapaAvisos extends PureComponent {
    state = {
        day: 0,
        data: [],
        meteorsNav: {
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false,
            7: false,
        },
        isMarkersSet: false,
        maxPerillPerDay: {
            0: PERILL_GRADES[0],
            1: PERILL_GRADES[0],
            2: PERILL_GRADES[0],
        },
    };

    static propTypes = {
        config: PropTypes.shape({
            language: PropTypes.string,
            target: PropTypes.string,
        }),
        data: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.shape({
                    avisos: PropTypes.arrayOf(PropTypes.object),
                    estat: PropTypes.object,
                    meteor: PropTypes.shape({
                        nom: PropTypes.string,
                    }),
                })
            )
        ),
        widgetDate: PropTypes.string,
    };

    dayMarkers = [];

    render() {
        const { day, meteorsNav } = this.state;
        const { preview, config, widgetDate } = this.props;
        const { language, color, target } = config;

        return (
            <div
                className="WidgetMapaAvisos mc-widget mc-avisos"
                style={{
                    width: !preview ? '100%' : null,
                    height: !preview ? '100%' : null,
                    // eslint-disable-next-line
                    height: !preview ? 'calc(100vh - 20px)' : null,
                }}
            >
                <Header color={color} logo={logo} target={target} />
                <div className="mc-widget-wrapper">
                    <Nav
                        alternativeTitle={translate(language, 'avisos_title')}
                        language={language}
                        alternativeMenu={translate(
                            language,
                            'mapa_avisos_nav_link'
                        )}
                        linkAlternativeMenu={`${links.baseMeteo}${
                            links.avisosPrediccioGral
                        }`}
                        widgetDate={widgetDate}
                        target={target}
                    />
                    <DayNav
                        numberOfDays={3}
                        dayAfterTomorrow={dayAfterTomorrow(language, 'long')}
                        currentDay={day}
                        dayNavigation={this.dayNavigation}
                        color={dayNavColor(color)}
                        language={language}
                        maxPerillPerDay={this.state.maxPerillPerDay}
                    />
                    <div className="mc-widget-content">
                        <div>
                            <AvisosNav
                                meteorsNav={meteorsNav}
                                avisosNavigation={this.avisosNavigation}
                                markers={this.dayMarkers[day]}
                                language={language}
                            />
                        </div>
                        <div className="map-wrapper">
                            {this.getAvisosObject() && (
                                <Avisos
                                    data={this.getAvisosObject()}
                                    currentDay={day}
                                    meteorsNav={meteorsNav}
                                    preview={preview}
                                />
                            )}
                        </div>
                        <Legend language={language} />
                    </div>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        const { data } = this.props;
        if (data && data !== prevProps.data) {
            this.setState({ data });
        }

        if (
            this.state.data !== prevState.data ||
            this.state.day !== prevState.day
        ) {
            if (!this.state.isMarkersSet) this.setMarkersObject();
            this.initializeMeteorsNav();
        }
    }

    setMarkersObject() {
        const { data } = this.state;

        const days = [0, 1, 2];
        const dayMarkers = {};

        days.forEach(day => {
            let markersState = [];
            const dataDay = data[day];
            if (dataDay) {
                meteors.forEach(meteor => {
                    let avisData = dataDay.filter(
                        data => data.meteor.nom === meteor.nom
                    );

                    const avisosVigents = this.getAvisosVigents(
                        avisData,
                        day
                    ).map(afectacio => afectacio.perill);

                    const avisosObservacio = this.getAvisosObservacio(
                        avisData
                    ).map(afectacio => afectacio.perill);

                    const perills = [...avisosVigents, ...avisosObservacio];

                    markersState = [
                        ...markersState,
                        {
                            perillModerat:
                                perills.includes(1) || perills.includes(2),
                            perillAlt:
                                perills.includes(3) || perills.includes(4),
                            perillMoltAlt:
                                perills.includes(5) || perills.includes(6),
                        },
                    ];
                });

                dayMarkers[day] = markersState;
            }

            this.dayMarkers = dayMarkers;
            this.setState({ isMarkersSet: true });
            this.getMaxPerillPerDay();
        });
    }

    initializeMeteorsNav() {
        const markers = this.dayMarkers[this.state.day];
        if (markers) {
            const markerKeys = markers.map(obj => {
                return obj.perillModerat || obj.perillAlt || obj.perillMoltAlt
                    ? true
                    : false;
            });
            const meteorsNav = { ...markerKeys };
            this.setState({ meteorsNav });
            this.getAvisosObject();
        }
    }

    getAvisosObject() {
        const { data, day } = this.state;
        if (data[day]) {
            const dayData = data[day];

            // Lets filter data. We just want data related to enabled meteors
            const filteredData = dayData.reduce((accumulator, current) => {
                // Index property of the meteor object in meteors array for the current meteor
                const meteorKey = Object.keys(meteors).find(
                    key => meteors[key].nom === current.meteor.nom
                );
                const meteorIndex = meteors[meteorKey].index;
                // If the meteor is enabled we want to include current data
                // Sea conditions always in because we need to repaint border color if not enabled (in Avisos component)
                if (this.state.meteorsNav[meteorIndex] || meteorKey === '3') {
                    return [...accumulator, current];
                } else {
                    // If meteor isn't enabled skip current
                    return [...accumulator];
                }
            }, []);

            // Avisos
            /* Transform data into an object with shape as follows:
                { 
                    idComarca: perillMésAltComarca1, 
                    idComarca2: perillMésAltComarca2,
                    ...
                }
            */

            let avisos = this.getAvisosVigents(filteredData).reduce(
                (accumulator, current) => {
                    // Do we have a property for this comarca? If so lets find out if current value is higher
                    if (accumulator[current.idComarca]) {
                        if (accumulator[current.idComarca] > current.perill)
                            return accumulator;
                        accumulator[current.idComarca] = current.perill;
                        return accumulator;
                    }
                    // if we dont have a porperty with this comarcaId, just add it to the object
                    return {
                        ...accumulator,
                        [current.idComarca]: current.perill,
                    };
                },
                {}
            );

            // Avisos d'observació
            /* Transform data into an object with shape as follows:
                { 
                    idComarca: perillMésAltComarca1, 
                    idComarca2: perillMésAltComarca2,
                    ...
                }
            */
            const avisosObservacio = this.getAvisosObservacio(
                filteredData
            ).reduce((accumulator, current) => {
                // Do we have a property for this comarca? If so lets find out if current value is higher
                if (accumulator[current.idComarca]) {
                    if (accumulator[current.idComarca] > current.perill)
                        return accumulator;
                    accumulator[current.idComarca] = current.perill;
                    return accumulator;
                }
                // if we dont have a porperty with this comarcaId, just add it to the object
                return { ...accumulator, [current.idComarca]: current.perill };
            }, {});

            // Merge objects & pick higher value for each property
            const avisosObservacioKeys = Object.keys(avisosObservacio);
            let avisosMerged = { ...avisos };

            // For each key in avisosObservacio insert in avisosMerged if it doesn' exist or select higher value
            avisosObservacioKeys.forEach(key => {
                if (!avisosMerged[key]) {
                    avisosMerged = {
                        ...avisosMerged,
                        [key]: avisosObservacio[key],
                    };
                } else {
                    avisosMerged[key] =
                        avisosMerged[key] > avisosObservacio[key]
                            ? avisosMerged[key]
                            : avisosObservacio[key];
                }
            });

            return avisosMerged;
        }
        return {};
    }

    // Returns an array of afectacions objects matching the criteria
    getAvisosVigents(data, day = this.state.day) {
        return (
            data
                .map(episodi => episodi.avisos)
                // flatten
                .reduce(
                    (accumulator, current) => accumulator.concat(current),
                    []
                )
                // // just tipus "Avís" & estat = "Vigent"
                .filter(
                    avisos =>
                        avisos.tipus === 'Avís' && avisos.estat === 'Vigent'
                )
                // Just current day evolucions
                .map(vigent => this.currentDayEvolucio(vigent.evolucions, day))
                .map(evolucio => evolucio.periodes)
                .reduce(
                    (accumulator, current) => accumulator.concat(current),
                    []
                )
                .map(periode => periode.afectacions)
                // remove empty arrays
                .filter(arr => arr)
                .reduce(
                    (accumulator, current) => accumulator.concat(current),
                    []
                )
        );
    }

    // Returns an array of afectacions objects matching the criteria
    getAvisosObservacio(data) {
        return (
            data
                .map(av => av.avisos)
                // flatten
                .reduce(
                    (accumulator, current) => accumulator.concat(current),
                    []
                )
                // just avisos d'observació i avisos de temps violent
                .filter(
                    avisos =>
                        (avisos.tipus === "Avís d'Observació" ||
                            avisos.tipus === 'Avís temps violent') &&
                        avisos.estat === 'Vigent'
                )
                .map(periode => periode.afectacions)
                // remove null arrays
                .filter(arr => arr)
                .reduce(
                    (accumulator, current) => accumulator.concat(current),
                    []
                )
        );
    }

    dayNavigation = day => {
        this.setState({ day });
        this.initializeMeteorsNav();
    };

    avisosNavigation = type => {
        const meteorsNav = { ...this.state.meteorsNav };
        meteorsNav[type] = !meteorsNav[type];

        this.setState({ meteorsNav });
        this.getAvisosObject();
    };

    currentDayEvolucio(evolucions, day = this.state.day) {
        let date = DateTime.local()
            .plus({ days: day })
            .toISODate();

        const currentEvolucio = evolucions.find(evolucio => {
            const jsonDate = DateTime.fromISO(evolucio.dia).toISODate();
            return jsonDate === date;
        });
        return currentEvolucio;
    }

    getMaxPerillPerDay() {
        const maxPerillPerDay = {};
        const days = [0, 1, 2];

        days.forEach(day => {
            if (!this.dayMarkers[day]) {
                // sense perill if no data available
                maxPerillPerDay[day] = PERILL_GRADES.sense;
            } else {
                const maxPerillPerMeteor = this.dayMarkers[day].reduce(
                    (accumulator, current) => {
                        // get max perill for each meteor
                        const marker = current.perillMoltAlt
                            ? PERILL_GRADES.moltAlt
                            : current.perillAlt
                                ? PERILL_GRADES.alt
                                : current.perillModerat
                                    ? PERILL_GRADES.moderat
                                    : PERILL_GRADES.sense;
                        return [...accumulator, marker];
                    },
                    []
                );

                let maxPerill = '';
                // determine max perill per day
                switch (true) {
                    case maxPerillPerMeteor.includes(PERILL_GRADES.moltAlt):
                        maxPerill = PERILL_GRADES.moltAlt;
                        break;
                    case maxPerillPerMeteor.includes(PERILL_GRADES.alt):
                        maxPerill = PERILL_GRADES.alt;
                        break;
                    case maxPerillPerMeteor.includes(PERILL_GRADES.moderat):
                        maxPerill = PERILL_GRADES.moderat;
                        break;
                    default:
                        maxPerill = PERILL_GRADES.sense;
                }

                maxPerillPerDay[day] = maxPerill;
            }
        });

        this.setState({ maxPerillPerDay });
    }
}



// WEBPACK FOOTER //
// ./src/widgets/MapaAvisos/WidgetMapaAvisos.js